import { useEffect, useMemo, useState } from "react"
import _ from "underscore";
import services from "../../../services/services";
import { dateConvert, formatDateObject, getCustomPaginationValues } from "../../../utils/Helper";
import { decryptData, encryptData } from "../../../utils/encrypt";
import { DateObject } from "react-multi-date-picker";

export const useServiceError = ({ autopopData, projectChanged }) => {

    const [errorData, setErrorData] = useState({ x_axis: [], y_axis: [], api_data: [], max_data: 0 });
    const [showPopup, setShowPopup] = useState(false);
    const [popupData, setPopupData] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [hoveredRange, setHoveredRange] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filterValues, setFilterValues] = useState({ service: [], server: [], date: {} });
    const [filterCount, setFilterCount] = useState(0);
    const [apiData, setApiData] = useState([]);
    const [expand, setExpand] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [displayPageOutOfTotal, setDisplayPageOutOfTotal] = useState("");
    const [showPagination, setShowPagination] = useState(false);
    const [allPopupData, setAllPopupData] = useState(0);
    const [time, setTime] = useState({ from: null, to: null });
    const [intervalFlag, setIntervalFlag] = useState(false);
    const [defaultClicked, setDefaultClicked] = useState(true);

    useEffect(() => {
        handleDateRange(null, true);
    }, [])

    useEffect(() => {
        getData()
    }, [projectChanged])

    useEffect(() => {
        const interval = setInterval(() => {
            if (defaultClicked) {
                handleDateRange(null, true);
            } else {
                getData();
            }
        }, 120000);

        return () => clearInterval(interval);
    }, [intervalFlag]);

    useEffect(() => {
        // sorting
        let xAxisCategory = [];
        autopopData?.service_name?.forEach((item) => {
            let serviceObj = {
                name: "",
                count: 0
            }
            const findService = _.filter(apiData, { service_name: item });
            serviceObj.name = item;
            serviceObj.count = findService?.length;
            if (_.isEmpty(_.findWhere(xAxisCategory, { name: item }))) {
                xAxisCategory.push(serviceObj);
            }
        })

        xAxisCategory = _.sortBy(xAxisCategory, "count")?.reverse();

        const servers = _.uniq(_.pluck(apiData, "server"));
        let series = [];
        let popupServer = {}

        // set series
        if (!_.isEmpty(servers)) {
            servers?.forEach((server) => {
                let obj = {
                    name: server,
                    data: []
                }
                xAxisCategory?.forEach((service) => {
                    const findData = _.filter(apiData, { server: server, service_name: service.name });
                    obj.data.push(findData?.length);
                })
                series.push(obj);
            })
        } else {
            let dataArray = Array.from({ length: xAxisCategory?.length }, (v, i) => i);
            dataArray = dataArray.map((item) => item = 0);
            series.push({ name: "", data: dataArray });
        }

        const combineData = _.pluck(series, "data");
        const maxArray = Array.from({ length: xAxisCategory?.length }, (_, i) =>
            combineData?.reduce((sum, arr) => sum + (arr[i] || 0), 0)
        );

        setErrorData({ x_axis: xAxisCategory, y_axis: series, api_data: apiData, server_data: popupServer, max_data: Math.max(...maxArray) })
    }, [apiData, autopopData])

    const handleDateRange = (e, defaultFlag) => {
        if (e === null) {
            const now = new DateObject();
            const oneMinuteAgo = new DateObject().subtract(1, "hour");
            const range = [new DateObject(oneMinuteAgo), new DateObject(now)];
            setHoveredRange(range);
            setTime({ from: oneMinuteAgo?.toDate(), to: now?.toDate() });
            defaultFlag && handleApplyFilters(range) && setDefaultClicked(true);
        } else {
            setHoveredRange(e);
            setDefaultClicked(false);
        }
    }

    const handleApplyFilters = (dateRange) => {
        let dates;
        if (dateRange) {
            dates = {
                from_date: dateConvert(dateRange?.[0]?.toDate(), "iso-string")?.split(".")?.[0],
                to_date: dateConvert(dateRange?.[1]?.toDate(), "iso-string")?.split(".")?.[0]
            }
        } else {
            dates = {
                from_date: formatDateObject(hoveredRange?.[0], time?.from),
                to_date: formatDateObject(hoveredRange?.[1], time?.to)
            }
        }
        const serviceFilters = {
            dates: dates,
            server: filterValues?.server,
            service: filterValues?.service,
        }
        sessionStorage.setItem("sefilters", encryptData(JSON.stringify(serviceFilters)));

        // set count of filters applied
        let count = 0;
        if ((hoveredRange === undefined || _.isEmpty(hoveredRange)) && (dateRange === undefined || _.isEmpty(dateRange))) {
            count = 0;
        } else {
            count++;
        }
        Object.keys(filterValues)?.forEach((item) => {
            if (filterValues[item].length > 0) {
                count++;
            }
        })
        setFilterCount(count);
        setShowFilter(false);
        sessionStorage.getItem("inspectra_error_view") && getData();
        setIntervalFlag(!intervalFlag);
    }

    const handleDefaultFilters = () => {
        handleDateRange(null, false);
        setDefaultClicked(true);
        setFilterValues((prev) => ({ ...prev, service: [], server: [] }));
    }

    const getData = async () => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            if (!_.isEmpty(selectedProject)) {
                setLoader(true);
                const filters = JSON.parse(decryptData(sessionStorage.getItem("sefilters")) || "{}");
                setFilterValues((prev) => ({ ...prev, date: filters?.dates }));
                const payload = {
                    type: 'error',
                    fromDate: filters?.dates?.from_date,
                    toDate: filters?.dates?.to_date,
                    server: _.isEmpty(filters?.server) ? undefined : filters?.server?.toString(),
                    service_name: _.isEmpty(filters?.service) ? undefined : filters?.service?.toString(),
                    project_name: selectedProject?.project_key
                }
                const response = await services.callInspectra("GET", '/elsinspectra/top', payload);
                if (response) {
                    const data = response?.data;
                    setApiData(data);
                    setLoader(false);
                }
            }
        } catch (error) {
            console.error("Error getting Server Error Data: ", error);
            setLoader(false);
        }
    }

    const options = {
        credits: { enabled: false },
        chart: {
            type: 'column',
            scrollablePlotArea: {
                minWidth: Math.max(1200, autopopData?.service_name?.length * 33),
                scrollPositionX: 0
            },
            events: {
                render: function () {
                    const chart = this;
                    chart.xAxis[0].ticks &&
                        Object.values(chart.xAxis[0].ticks).forEach(tick => {
                            if (tick.label && !tick.label.clickAttached) {
                                tick.label.element.style.cursor = 'pointer';
                                const categoryName = tick.label.textStr;
                                tick.label.element.onclick = () => {
                                    handleShowDetailsPopup(categoryName, true);
                                };
                                tick.label.clickAttached = true;
                            }
                        });
                }
            }
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: _.pluck(errorData?.x_axis, "name"),
            scrollbar: {
                enabled: true
            },
        },
        yAxis: {
            min: 0,
            max: errorData?.max_data,
            tickInterval: 1,
            title: {
                text: '',
            },
        },
        plotOptions: {
            column: {
                stacking: "normal",
                // groupPadding: 0,
                pointWidth: 20,
                point: {
                    events: {
                        click: function (e) {
                            handleShowDetailsPopup(e);
                        }
                    }
                },
            },
        },
        tooltip: {
            style: {
                zIndex: 9999
            },
            enabled: true,
            formatter: function () {
                return `<div><span style="font-size:12px;">Server: <b>${this?.series?.name} </b><span style="color:${this.color};">\u25CF</span></span><br/></div><br/> Service: <b>${this.x}</b><br/> Errors: <b>${this.point.y} </b>`;
            }
        },
        legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
        },
        series: errorData?.y_axis
    };

    const handleShowDetailsPopup = async (event, isServiceName) => {
        let serviceName = '';
        if (event?.point) {
            const clickedPoint = event?.point;
            const serviceIndex = clickedPoint?.index;
            serviceName = errorData?.x_axis?.[serviceIndex]?.name;
        } else if (isServiceName) {
            serviceName = event;
        }
        const data = _.filter(errorData?.api_data, { service_name: serviceName });
        setAllPopupData(data);
        let pluckIds = [];
        if (data?.length <= 10 && data?.length > 0) {
            setShowPagination(false)
            setTotalPages(0);
            setCurrentPage(1);
            setDisplayPageOutOfTotal("");
            pluckIds = _.pluck(data, "_id");
            getServiceDetails(pluckIds);
        } else if (data?.length > 10) {
            const paginationValues = getCustomPaginationValues(currentPage, data?.length);
            setTotalPages(paginationValues?.total);
            setDisplayPageOutOfTotal(paginationValues?.displayPageOutOfTotal);
            for (let i = 0; i < 10; i++) {
                pluckIds.push(data[i]?._id);
            }
            getServiceDetails(pluckIds);
            setShowPagination(true);
            setShowPopup(true);
        }
    }

    const getServiceDetails = async (pluckIds) => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            const payload = {
                type: 'error',
                project_name: selectedProject?.project_key,
                _id: pluckIds
            }
            const response = await services.callInspectra("POST", '/elsinspectra/top/details', payload);
            if (response) {
                const apiData = response?.data;
                if (!_.isEmpty(apiData)) {
                    setPopupData(apiData);
                    setShowPopup(true);
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handlePageChange = (val) => {
        setCurrentPage(val);
        const paginationValues = getCustomPaginationValues(val, allPopupData?.length);
        setDisplayPageOutOfTotal(paginationValues?.displayPageOutOfTotal);
        const dataRange = paginationValues?.displayPageOutOfTotal?.split(" ")?.[0]?.split("-");
        dataRange.map((item) => parseInt(item));
        let pluckIds = [];
        for (let i = dataRange[0] - 1; i < dataRange[1]; i++) {
            pluckIds.push(allPopupData[i]?._id);
        }
        getServiceDetails(pluckIds);
    }

    return useMemo(() => ({
        options, showPopup, setShowPopup, popupData, expandedIndex, setExpandedIndex, hoveredRange, setHoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, expand, setExpand, totalPages, currentPage, setCurrentPage, displayPageOutOfTotal, handlePageChange, showPagination, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters
    }), [options, showPopup, setShowPopup, popupData, expandedIndex, setExpandedIndex, hoveredRange, setHoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, expand, setExpand, totalPages, currentPage, setCurrentPage, displayPageOutOfTotal, handlePageChange, showPagination, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters])
}